import styled from "@emotion/styled";
import React from "react";
import SizedBox from "@components/SizedBox";
import LinkGroup from "@components/LinkGroup";
import Divider from "@components/Divider";
import Wallet from "@components/Wallet/Wallet";
import Scrollbar from "@components/Scrollbar";
import { Column } from "../Flex";
import { observer } from "mobx-react-lite";
import { ROUTES } from "@src/constants";
import { ReactComponent as MediumIcon } from "@src/assets/links/medium.svg";
import { ReactComponent as XIcon } from "@src/assets/links/x.svg";
import { ReactComponent as TelegramIcon } from "@src/assets/links/telegram.svg";
import { ReactComponent as RobotIcon } from "@src/assets/links/robot.svg";
import { ReactComponent as GuidebookIcon } from "@src/assets/links/guidebook.svg";
import { ReactComponent as RomeLogo } from "@src/assets/tokens/ROME.svg";
import { THEME_TYPE } from "@src/themes/ThemeProvider";
import { useStores } from "@src/stores";
interface IProps {
  onClose: () => void;
  bannerClosed?: boolean;
  opened: boolean;
}

const Root = styled.div<{ bannerClosed: boolean; opened: boolean }>`
  z-index: 100;
  position: absolute;
  // top: ${({ bannerClosed }) => (bannerClosed ? 64 : 144)}px;
  top: 64px;
  left: 0;
  right: 0;
  transition: 0.2s;
  overflow: hidden;

  ${({ opened }) => (!opened ? `height: 0px;` : "")}
  .menu-body {
    justify-content: space-between;
    height: calc(100dvh - 64px);
    touch-action: none;
    overflow: hidden;
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.white};
  }
`;

const WalletWrapper = styled.div`
  padding: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.primary100};
`;

const MenuContainer = styled(Scrollbar)`
  height: 80%;
  width: 100%;
  margin: 24px;
  margin-bottom: 0px;
`;

const MobileMenu: React.FC<IProps> = ({
  bannerClosed = false,
  opened,
  onClose
}) => {
  const { accountStore } = useStores();
  const isDarkTheme = accountStore.selectedTheme === THEME_TYPE.DARK_THEME;

  const communityMenu = [
    {
      name: "Telegram",
      link: "https://t.me/puzzleswap",
      icon: <TelegramIcon className={isDarkTheme ? "theme_icon" : ""} />
    },
    {
      name: "(X) Twitter",
      link: "https://twitter.com/puzzle_swap",
      icon: <XIcon className={isDarkTheme ? "theme_icon" : ""} />
    },
    {
      name: "Medium",
      link: "https://medium.com/@puzzlenetwork",
      icon: <MediumIcon className={isDarkTheme ? "theme_icon" : ""} />
    }
  ];

  const toolsMenu = [
    {
      icon: <GuidebookIcon className={isDarkTheme ? "theme_icon" : ""} />,
      name: "Guidebook",
      link: "https://puzzle-lend.gitbook.io/guidebook",
      isExternalLink: true
    },
    {
      icon: <TelegramIcon className={isDarkTheme ? "theme_icon" : ""} />,
      name: "Puzzle Lend Chat",
      link: "https://t.me/puzzlelend",
      isExternalLink: true
    },
    {
      icon: <RobotIcon className={isDarkTheme ? "theme_icon" : ""} />,
      name: "Puzzle Lend bot",
      link: "https://t.me/PuzzleLendBot",
      isExternalLink: true
    },
    {
      icon: <RobotIcon className={isDarkTheme ? "theme_icon" : ""} />,
      name: "Notification bot",
      link: "https://t.me/puzzle_swap",
      isExternalLink: true
    },
    {
      icon: <RobotIcon className={isDarkTheme ? "theme_icon" : ""} />,
      name: "Alerts bot",
      link: "https://t.me/puzzle_alerts_bot",
      isExternalLink: true
    },
    {
      icon: <GuidebookIcon className={isDarkTheme ? "theme_icon" : ""} />,
      name: "Terms of Use",
      link: ROUTES.TERMS_OF_SERVICE,
      isExternalLink: false
    }
  ];

  const mainFunctional = [
    { name: "Dashboard", link: ROUTES.DASHBOARD },
    { name: "New Market", link: "/3PP9NsYNdmXTqt5bseaegRKHUE76F9MHGgW" },
    { name: "Old Market", link: "/3P4uA5etnZi4AmBabKinq2bMiWU8KcnHZdH" },
    {
      name: "ROME Market",
      icon: <RomeLogo style={{ borderRadius: 500, width: 22, height: 22 }} />,
      link: "/3P8Df2b7ywHtLBHBe8PBVQYd3A5MdEEJAou"
    },
    { name: "Waves DeFi", link: "/3P4DK5VzDwL3vfc5ahUEhtoe5ByZNyacJ3X" },
    { name: "Low Cap", link: "/3PHpuQUPVUoR3AYzFeJzeWJfYLsLTmWssVH" },
    {
      name: "Axly Market",
      link: "https://app.axly.io/lend",
      isExternalLink: true
    }
  ];
  return (
    <Root {...{ bannerClosed, opened }}>
      <div className="menu-body">
        <MenuContainer>
          <Column crossAxisSize="max">
            <LinkGroup onClick={onClose} title="" links={mainFunctional} />
            <SizedBox height={24} />
            <LinkGroup title="Tools" links={toolsMenu} />
            <SizedBox height={24} />
            <LinkGroup title="Community" links={communityMenu} />
            <SizedBox height={24} width={1} />
          </Column>
        </MenuContainer>

        <WalletWrapper>
          <Wallet />
        </WalletWrapper>
      </div>
    </Root>
  );
};
export default observer(MobileMenu);
